import type { ReactNode } from 'react'
import { useState } from 'react'
import type { CenaTabletop, ObjetoTabletop } from '../../dominio/tabletop/tipos'
import { SeletorCenarioModal } from './SeletorCenarioModal'
import type { RetornoUseAtendimentoTabletop } from './useAtendimentoTabletop'
import { FichaVitimaMesa } from './FichaVitimaMesa'

interface Props {
  secao: 'cenario' | 'vitima' | 'corte' | 'estabilizacao'
  cena: CenaTabletop
  selecionado: ObjetoTabletop | null
  cenarioId: string
  aoSelecionar: (id: string) => void
  aoAlterarHistoria: (texto: string) => void
  aoCarregarCenario: (id: string) => void
  aoVincularFicha: (id: string, fichaId: string | null) => void
  atendimento: Pick<RetornoUseAtendimentoTabletop, 'sessao' | 'revelar' | 'evoluirEstado'>
  editor: ReactNode
  operacoes: (objeto: ObjetoTabletop, secao: 'corte' | 'estabilizacao') => ReactNode
}

export function PainelMesaTabletop(p: Props) {
  const [exemplosAbertos, setExemplosAbertos] = useState(false)
  const vitimas = p.cena.objetos.filter(o => o.vitima)
  const veiculos = p.cena.objetos.filter(o => o.veiculo)
  const vitima = p.selecionado?.vitima ? p.selecionado : vitimas[0]
  const veiculo = p.selecionado?.veiculo ? p.selecionado : veiculos[0]
  const localVitima = (o: ObjetoTabletop) => {
    const local = o.vitima!.local
    return local.tipo === 'solo' ? 'Solo' : `${p.cena.objetos.find(v => v.id === local.idVeiculo)?.nome ?? 'Veículo'} · ${local.idAncora}`
  }

  return <div className="tt-painel-mesa">
    {p.secao === 'cenario' && <>
      <h3>História inicial</h3>
      <label className="campo">
        <span>Contexto da ocorrência</span>
        <textarea aria-label="História inicial" rows={8} value={p.cena.historiaInicial ?? ''}
          placeholder="Escreva livremente a história deste acidente…"
          onChange={e => p.aoAlterarHistoria(e.target.value)} />
      </label>
      <p className="dica">Salvo automaticamente com a cena. Todos podem consultar e editar.</p>
      <button type="button" onClick={() => setExemplosAbertos(true)}>Carregar exemplo</button>
      <details>
        <summary>Elementos na mesa ({p.cena.objetos.length})</summary>
        <div className="tt-lista-mesa">
          {p.cena.objetos.map(o => <button type="button" key={o.id}
            aria-pressed={p.selecionado?.id === o.id} onClick={() => p.aoSelecionar(o.id)}>
            {o.nome}{o.bloqueado ? ' · Bloqueado' : ''}{o.oculto ? ' · Oculto' : ''}
          </button>)}
        </div>
      </details>
    </>}
    {p.secao === 'vitima' && <>
      <h3>Vítimas ({vitimas.length})</h3>
      <div className="tt-lista-mesa" role="group" aria-label="Vítimas na mesa">
        {vitimas.map((o, i) => <button type="button" key={o.id}
          aria-pressed={vitima?.id === o.id} onClick={() => p.aoSelecionar(o.id)}>
          V{i + 1} · {o.nome} · {localVitima(o)}
        </button>)}
      </div>
      {vitima ? <>
        <h3>{vitima.nome}</h3><p>{localVitima(vitima)}</p>
        <FichaVitimaMesa objeto={vitima} aoVincularFicha={p.aoVincularFicha}
          sessao={p.atendimento.sessao} aoVerificar={p.atendimento.revelar} aoMudarEstagio={p.atendimento.evoluirEstado} />
        {p.selecionado?.id === vitima.id && <details>
          <summary>Posição, postura e aparência</summary>{p.editor}
        </details>}
      </> : <p>Adicione uma vítima à mesa para configurar sua ficha.</p>}
    </>}
    {(p.secao === 'corte' || p.secao === 'estabilizacao') && <>
      <label className="campo"><span>Veículo</span>
        <select aria-label="Veículo para operações" value={veiculo?.id ?? ''}
          onChange={e => p.aoSelecionar(e.target.value)}>
          {!veiculos.length && <option value="">Nenhum veículo</option>}
          {veiculos.map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}
        </select>
      </label>
      {veiculo ? p.operacoes(veiculo, p.secao) : <p>Adicione um carro para usar as ferramentas.</p>}
    </>}
    <SeletorCenarioModal mesaCompartilhada aberto={exemplosAbertos} cenarioAtualId={p.cenarioId}
      aoSelecionarCenario={id => { p.aoCarregarCenario(id); setExemplosAbertos(false) }}
      aoFechar={() => setExemplosAbertos(false)} />
  </div>
}
